import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = { 
    theme: {
        themes: {
          light: {
            primary: '#559e83',
            secondary: '#b0bec5',
          },
        },
      },

    icons: {  iconfont: 'mdi', } };

export default new Vuetify(opts);


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js